import { useMemo } from "react";
import { useGetPackagingData as useGetFarmGatePackagingData } from "../../../../../api/farmGate/packaging";
import { useGetPackagingData as useGetProcessGatePackagingData } from "../../../../../api/processGate/packaging";
import { ApiPackaging } from "../../../../../types/prodcut-data-review/product-data.types";
import { GateKind } from "../types/packagingDetail.types";
import { mapPackagingDetail } from "../utils/packagingDetail.utils";

interface UsePackagingDetailParams {
  packagingId: string;
  gateKind: GateKind;
  /** Only fetch once the row is expanded. */
  enabled: boolean;
}

/**
 * Loads the full per-packaging record (levels + materials) from the same
 * detail endpoints the mapping-tool Packaging drawers use, instead of relying
 * on the bulk mapping-all-data payload which only carries id/name for packaging.
 */
export const usePackagingDetail = ({ packagingId, gateKind, enabled }: UsePackagingDetailParams) => {
  const farmGateQuery = useGetFarmGatePackagingData(gateKind === "farm" && enabled ? packagingId : undefined);
  const processGateQuery = useGetProcessGatePackagingData(
    gateKind === "process" && enabled ? packagingId : undefined
  );

  const activeQuery = gateKind === "farm" ? farmGateQuery : processGateQuery;
  const detail = activeQuery.data as ApiPackaging | undefined;

  const viewModel = useMemo(() => mapPackagingDetail(detail), [detail]);

  return {
    detail,
    ...viewModel,
    isLoading: activeQuery.isLoading,
    isError: activeQuery.isError,
    refetch: activeQuery.refetch
  };
};
